import vi from './locales/vi';

export const AppLocale = {
  vi: {
    locale: 'vi',
    messages: vi,
  },
};
